"use strict";

exports.__esModule = true;
exports.getPlantState = getPlantState;
exports.getPlantStateOrThrow = getPlantStateOrThrow;
var _Utils = require("../../Utils");
/**
 * Get the plant state with the given id
 * from an array of plant states.
 * If no corresponding state exists a temporary one will be created.
 */
function getPlantState(states, id) {
  for (var i = 0; i < states.length; i++) {
    var item = states[i];
    if (item.id === id) {
      return item;
    }
  }
  return {
    id: id,
    name: (0, _Utils.humanizeString)(id),
    show: false
  };
}

/**
 * Get the plant state with the given id
 * from an array of plant states.
 * @throws {Error} if no such state exists.
 */
function getPlantStateOrThrow(states, id) {
  for (var i = 0; i < states.length; i++) {
    var item = states[i];
    if (item.id === id) {
      return item;
    }
  }
  throw new Error("Could not find a PlantState with id: " + id);
}